<template>
    <div class="content">
        <TopBar barStyle="background-color: #fff;">
            <span class="page-title" slot="title">会员福利</span>
        </TopBar>
        <!--<div class="top-bar wrap vc">
            <div class="bar-left vc">
                <a class="icon-wrap" href="javascript: history.back()">
                    <i class="icon icon-return"></i>
                </a>
                <span class="page-title">会员权益说明</span>
            </div>
        </div>-->
        <div class="privilege" :style="`height: ${viewHeight}px`">
            <div class="part-nav">
                <div id="nav" class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="item in privilegeList" :key="item.id">
                            <span class="item-text el">{{item.name}}</span>
                        </div>
                        <div class="bar" :style="`width: ${navSlideWidth}; transform: translateX(${barLeft}px); -webkit-transform: translateX(${barLeft}px);`">
                            <div class="icon icon-line"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-detail">
                <div id="page" class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="item in privilegeList" :key="item.id" :style="`height: ${viewHeight}px`">
                            <div class="page-content">
                                <div class="content-top" v-if="item.outBlackIcon">
                                    <div class="pic-box hvc">
                                        <img :src="item.outBlackIcon" :alt="item.name">
                                    </div>
                                    <div class="text-box">{{item.name}}</div>
                                </div>
                                <div class="content-detail wrap">
                                    <ul>
                                        <li>
                                            <div class="item-title vc"><i class="icon icon-line"></i>福利内容</div>
                                            <div class="item-detail" v-html="item.content"></div>
                                        </li>
                                        <li>
                                            <div class="item-title vc"><i class="icon icon-line"></i>使用说明</div>
                                            <div class="item-detail" v-html="item.useDirections"></div>
                                        </li>
                                        <li>
                                            <div class="item-title vc"><i class="icon icon-line"></i>福利规则</div>
                                            <div class="item-detail" v-html="item.rule"></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="btn-wrap hvc" v-if="item.immediatelyUseFlag">
                                <a class="btn-item btn-use hvc" :href="item.immediatelyUseLink">立即使用</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import 'swiper/dist/css/swiper.css'
    import Swiper from 'swiper'
    import { delayDev } from '@/libs/tools'
    import TopBar from '@/components/top-bar/'
    export default {
        name: 'privilege',
        components: {
            TopBar
        },
        data: () => {
            return {
                userLevel: 1,
                privilegeList: [],
                viewHeight: 'auto',
                navSwiper: null,
                navSlideWidth: 0,
                navSum: 0,
                clientWidth: 0,
                navWidth: 0,
                pageSwiper: null,
                barLeft: 0,
                activeIndex: 0,
                activeSlidePosition: 0,
                navActiveSlideLeft: 0
            }
        },
        created () {
            this.getUserPrivilege()
                .then(res => {
                    this.privilegeList = res
                    delayDev(300, () => {
                        let that = this
                        this.navSlide()
                        this.pageSlide()
                        this.navSwiper.$el.on('touchstart', function (e) {
                            e.preventDefault()
                        })
                        this.navSwiper.on('tap', function () {
                            let clickIndex = this.clickedIndex
                            let clickSlide = this.slides.eq(clickIndex)
                            that.pageSwiper.slideTo(clickIndex, 0);
                            this.slides.find('.item-text').removeClass('cur')
                            clickSlide.find('.item-text').addClass('cur')
                        })
                    })
                })
        },
        mounted () {
            this.adaptView()
            this.getUserLevelPrivilege()
                .then(res => {
                    this.userLevel = this.getLevel(res.customerInfo.userLevel)
                })
            this.activeIndex = parseInt(this.$route.query.index)
        },
        methods: {
            adaptView () {
                let $target = document.querySelector('.privilege')
                let viewHeight = window.innerHeight
                let targetHeight = $target.offsetHeight
                if (viewHeight > targetHeight) {
                    this.viewHeight = viewHeight
                }
            },
            getUserPrivilege () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPrivilege',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            navSlide () {
                let that = this
                this.navSwiper = new Swiper('#nav', {
                    initialSlide: this.activeIndex,
                    slidesPerView: 3.5,
                    freeMode: true,
                    on: {
                        init: function() {
                            this.slides.eq(that.activeIndex).find('.item-text').addClass('cur')
                            that.navSlideWidth = this.slides.eq(that.activeIndex).css('width');
                            that.navSum = this.slides[this.slides.length - 1].offsetLeft
                            that.clientWidth = parseInt(this.$wrapperEl.css('width'))
                            for (let i = 0, len = this.slides.length; i < len; i++) {
                                that.navWidth += parseInt(this.slides.eq(i).css('width'))
                            }
                        }
                    }
                })
            },
            pageSlide () {
                let that = this
                this.pageSwiper = new Swiper('#page', {
                    initialSlide: this.activeIndex,
                    watchSlidesProgress: true,
                    resistanceRatio: 0,
                    on: {
                        touchMove: function() {
                            that.barLeft = that.navSum * this.progress
                        },
                        transitionStart: function() {
                            let activeIndex= this.activeIndex
                            let navSwiper = that.navSwiper
                            let clientWidth = that.clientWidth
                            let navActiveSlideLeft = that.navSwiper.slides[activeIndex].offsetLeft
                            let navWidth = that.navWidth
                            let navSlideWidth = that.navSlideWidth
                            that.navActiveSlideLeft = navActiveSlideLeft
                            that.activeIndex = activeIndex
                            that.barLeft = navSwiper.slides[activeIndex].offsetLeft

                            navSwiper.setTransition(300)
                            navSwiper.slides.eq(activeIndex).find('.item-text').addClass('cur')
                            if (activeIndex > 0) {
                                navSwiper.slides.eq(activeIndex - 1).find('.item-text').removeClass('cur')
                            }
                            if (activeIndex < this.slides.length) {
                                navSwiper.slides.eq(activeIndex + 1).find('.item-text').removeClass('cur')
                            }
                            if (navActiveSlideLeft < (clientWidth - parseInt(navSlideWidth)) / 2) {
                                navSwiper.setTranslate(0)
                            } else if (navActiveSlideLeft > navWidth - (parseInt(navSlideWidth) + clientWidth) / 2) {
                                navSwiper.setTranslate(clientWidth - navWidth)
                            } else {
                                navSwiper.setTranslate((clientWidth - parseInt(navSlideWidth)) / 2 - navActiveSlideLeft)
                            }
                        }
                    }
                })
            },
            getUserLevelPrivilege () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserLevelPrivilege',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getLevel (userLevelText) {
                switch (userLevelText) {
                    case '初级会员':
                        return 1
                    case '高级会员':
                        return 2
                    case '精英会员':
                        return 3
                    case '卓越会员':
                        return 4
                }
            }
            /*checkType (type, userLevel) {
                if (type === 0 || type === 1 && userLevel === 1 || type === 2 && userLevel !== 1) return true
            }*/
        }
    }
</script>

<style lang="less" scoped>
    .top-bar{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        width: 100%;
        height: 1.00rem;
        background-color: #fff;
        border-bottom: #d3dbde solid 0.02rem;
        .bar-left{
            width: 3.00rem;
            height: 100%;
            .icon-wrap{
                display: block;
                width: 0.40rem;
                height: 0.40rem;
            }
            .icon-return{
                width: 0.32rem;
                height: 0.40rem;
                background: url("../../assets/images/return.png") no-repeat;
                background-size: 100% 100%;
            }
            .page-title{
                font-size: 0.30rem;
            }
        }
    }
    .privilege{
        background-color: #f5f6f8;
        .part-nav{
            position: fixed;
            left: 0;
            top: 1.00rem;
            z-index: 99;
            width: 100%;
            height: 1.00rem;
            background-color: #fff;
            .item-text{
                display: block;
                width: 90%;
                height: 1.00rem;
                margin: 0 auto;
                color: #747d80;
                line-height: 1.00rem;
                text-align: center;
                transition: all ease 0.3s;
                -webkit-transition: all ease 0.3s;
                &.cur{
                    color: #ffa70d;
                }
            }
            .bar{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 2.00rem;
                height: 0.04rem;
                background-color: #fac400;
                transition: all ease 0.3s;
                -webkit-transition: all ease 0.3s;
            }
        }
        .part-detail{
            height: 100%;
            .page-content{
                height: 100%;
                padding-top: 2.40rem;
                padding-bottom: 1.26rem;
                overflow-y: scroll;
                .content-top{
                    padding-bottom: 0.46rem;
                    .pic-box{
                        width: 1.50rem;
                        height: 1.50rem;
                        margin: 0 auto;
                        background-color: #fac400;
                        border-radius: 100%;
                        img{
                            width: 1.20rem;
                        }
                    }
                    .text-box{
                        padding-top: 0.12rem;
                        font-size: 0.30rem;
                        line-height: 0.48rem;
                        text-align: center;
                    }
                }
                .content-detail{
                    padding-top: 0.02rem;
                    ul{
                        li{
                            margin-bottom: 0.40rem;
                            .item-title{
                                padding-bottom: 0.34rem;
                                font-size: 0.30rem;
                                .icon-line{
                                    width: 0.04rem;
                                    height: 0.30rem;
                                    margin-right: 0.10rem;
                                    background-color: #fbc500;
                                    border-radius: 0.02rem;
                                }
                            }
                            .item-detail{
                                padding-left: 0.14rem;
                                color: #747d80;
                                line-height: 0.32rem;
                                word-break: break-all;
                                word-wrap: break-word;
                            }
                        }
                    }
                }
            }
            .btn-wrap{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                z-index: 9999;
                height: 1.26rem;
                border-top: #d4dbde solid 0.02rem;
                background-color: #fff;
                .btn-use{
                    display: flex;
                    display: -webkit-flex;
                    width: 6.92rem;
                    height: 0.95rem;
                    background-color: #fbc500;
                    border-radius: 0.05rem;
                    font-size: 0.30rem;
                }
            }
        }
    }
</style>
